import React, { useCallback, useEffect, useState } from "react";

import api from "../../util/panelApi";
import { PageHead, Tiles } from "./kit";

const cell = { padding: "7px 9px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13, width: "100%" };
const small = { fontSize: 12, color: "#6B7280" };

/// Sohbet cevirisi: saglayici ve anahtar. Anahtar girilmeden ozellik acilmaz.
const Translate = () => {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const r = await api.config();
    if (r?.status) {
      setCfg({
        translateEnabled: r.config.translateEnabled === true,
        translateProvider: r.config.translateProvider || "google",
        translateApiKey: r.config.translateApiKey || "",
        translateUrl: r.config.translateUrl || "",
      });
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const save = async () => {
    if (cfg.translateEnabled) {
      if (cfg.translateProvider === "libre" && !cfg.translateUrl.trim()) {
        return window.alert("LibreTranslate adresi gerekli.");
      }
      if (cfg.translateProvider === "google" && !cfg.translateApiKey.trim()) {
        return window.alert("Google Translate API anahtarı gerekli.");
      }
    }
    setSaving(true);
    const r = await api.saveConfig(cfg);
    setSaving(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    load();
  };

  if (!cfg) return <div className="badu-empty">Yükleniyor…</div>;

  return (
    <>
      <PageHead
        title="Sohbet Çevirisi"
        sub="Açıkken kullanıcılar sohbetteki mesajları kendi diline çevirebilir. Türkçe–Arapça karışık odalarda çok işe yarar."
      />

      <Tiles
        items={[
          { label: "Durum", value: cfg.translateEnabled ? "Açık" : "Kapalı" },
          { label: "Sağlayıcı", value: cfg.translateProvider === "libre" ? "LibreTranslate" : "Google" },
        ]}
      />

      <div className="card">
        <div className="card-body" style={{ maxWidth: 620 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
            <input
              type="checkbox"
              checked={cfg.translateEnabled}
              onChange={(e) => setCfg({ ...cfg, translateEnabled: e.target.checked })}
            />
            <b>Çeviri açık</b>
          </label>

          <div style={{ marginBottom: 12 }}>
            <div style={small}>Sağlayıcı</div>
            <select
              style={cell}
              value={cfg.translateProvider}
              onChange={(e) => setCfg({ ...cfg, translateProvider: e.target.value })}
            >
              <option value="google">Google Cloud Translation (ücretli, kaliteli)</option>
              <option value="libre">LibreTranslate (kendi sunucun, ücretsiz)</option>
            </select>
          </div>

          {cfg.translateProvider === "libre" && (
            <div style={{ marginBottom: 12 }}>
              <div style={small}>LibreTranslate adresi</div>
              <input
                style={cell}
                placeholder="https://ceviri.badulive.online"
                value={cfg.translateUrl}
                onChange={(e) => setCfg({ ...cfg, translateUrl: e.target.value })}
              />
            </div>
          )}

          <div style={{ marginBottom: 14 }}>
            <div style={small}>
              {cfg.translateProvider === "libre" ? "API anahtarı (varsa)" : "Google Translate API anahtarı"}
            </div>
            <input
              style={cell}
              type="password"
              placeholder="••••••••"
              value={cfg.translateApiKey}
              onChange={(e) => setCfg({ ...cfg, translateApiKey: e.target.value })}
            />
            <div style={{ ...small, marginTop: 6 }}>
              Google anahtarını Google Cloud Console → API ve Servisler → Kimlik bilgileri bölümünden alırsın.
              Cloud Translation API'yi açman ve faturalandırmayı etkinleştirmen gerekir.
            </div>
          </div>

          <button className="btn btn-primary" disabled={saving} onClick={save}>
            {saving ? "Kaydediliyor…" : "Kaydet"}
          </button>
        </div>
      </div>
    </>
  );
};

export default Translate;
